import SvgAlertTriangle from "@uui/AlertTriangle";

import { Alert, Typography } from "@mui/material";

import LINKS from "@app/common/links";

import Link from "@rui/Link";

const ZoomLocalRecordingDisabledAlert = () => {
  return (
    <Alert
      severity="warning"
      icon={
        <SvgAlertTriangle
          sx={{ fontSize: "18px", mt: 0.5, color: "chart.orange.dark" }}
        />
      }
    >
      <Typography
        variant="bodySecondaryReg"
        sx={{ color: "shades.neutral.800" }}
      >
        It appears you have local recording disabled in Zoom.{" "}
        <Link
          href={LINKS.SUPPORT.ZOOM_ENABLE_LOCAL_RECORDING}
          sx={{ color: "chart.orange.dark" }}
        >
          Update your recording settings in Zoom
        </Link>{" "}
        to enable local recording.
      </Typography>
    </Alert>
  );
};

export default ZoomLocalRecordingDisabledAlert;
